<div class="h-screen w-full flex flex-col">
  <sura-header />
  <div class="flex-1 w-full h-full px-3">
    <router-outlet />
  </div>
</div>
